module.exports = __webpack_public_path__ + "img/134.8.2d6b8f01.png";